module.exports = __webpack_public_path__ + "d67bf97e62d6dc639743b00faf739fc8.jpg";